import React, { Fragment, useContext, useState } from 'react'
import PropTypes from 'prop-types'
import {
  Row,
  Col,
  Button,
  Modal,
  Popconfirm,
  Tooltip,
  Input,
  Icon,
  Spin,
} from '../../common/UIComponents'
import { alertMessage, } from '../../common/Common'
import _ from 'lodash';
import { unlockInvoice } from '../../api/BillingScreenAPI'
import lockButton  from '../../../assets/images/lock_blue.png'
import lock from '../../../assets/images/lock.png';
import I18n from '../../common/I18n'
import { OrgContext } from '../../context/OrgContext'
import Button_v2 from '../../stories/components/Button_v2'

const UNLOCK_REASON_MAX_LENGTH = 500

const UnlockInvoice = ({
  buttonType,
  className,
  label,
  isDisabled,
  invoiceIds,
  size,
  handleSuccess,
  displayType,
  requireAction =  true,
  styleObj = {},
  selectedInfo,
  handleUnmount,
  indexList,
  handleOnModalClose,
  isFileGenerated = false,
  isPartiallyPaid,
  orgSettings: orgSettingsProp,
  requireUnlockReason: requireUnlockReasonProp = false,
  dataTestId = 'unlock',
}) => {
  const orgContext = useContext(OrgContext) || {}
  const requireUnlockReason = requireUnlockReasonProp
    || String(orgSettingsProp?.require_reason_on_invoice_unlock) === 'true'
    || String(orgContext.orgSettings?.require_reason_on_invoice_unlock) === 'true'
  const [loading, setLoading] = useState(false)
  const [reasonModalVisible, setReasonModalVisible] = useState(false)
  const [unlockReason, setUnlockReason] = useState('')
  const resetValues = (closeModal = false) => {
    setLoading(false)
  }

  const closeReasonModal = () => {
    if (loading) return
    setReasonModalVisible(false)
    setUnlockReason('')
  }

  const showErrors = (errors) => {
    if (errors.length > 0) {
      const firstError = errors[0];
      let title = "";
      let content = "";
      if(_.isObject(firstError)){
        const errorInvoices = errors.filter((err) => err.errors.length > 0)
        title = 'Following invoices could not be processed'
        content = (
          <div>
            {errorInvoices.map((err) => (
              <Row key={err.frequency_invoice_number}>
                <Col xs={24}>
                  <span className="textRed">{err.frequency_invoice_number}</span>:
                  &nbsp;
                  <span>{err.errors.join(',')}</span>
                </Col>
              </Row>
            ))}
          </div>
        );
      }else{
        title= "Errors";
        content= (<div>
            <Row key={'error'}>
              <Col xs={24}>
                <span>{errors.join(',')}</span>
              </Col>
            </Row>
        </div>);
      }
      return Modal.error({
        title,
        content,
        width: '40%',
      });
    }
  }
  const handleSave = async (reason) => {
    let invoiceNos;
    if (typeof selectedInfo === 'string') {
      invoiceNos = [selectedInfo];
    } else if (selectedInfo && selectedInfo.selectedRows) {
      invoiceNos = selectedInfo.selectedRows.map((invoice) => invoice.frequency_invoice_number);
    }
    const trimmedReason = typeof reason === 'string' ? reason.trim() : ''
    if (requireUnlockReason && !trimmedReason) {
      setReasonModalVisible(true)
      return
    }
    let showReasonModal = false
    try {
      const payload = {
        account_invoice_ids: invoiceIds ? invoiceIds.split(',') : []
      }
      if (trimmedReason) {
        payload.reason = trimmedReason
      }
      setLoading(true)
      let response = await unlockInvoice(payload)

      if (response.success) {
        const result = response?.invoices ? response.invoices : {}
        const successMessage = result?.message
          ? result.message
          : I18n.t('messages.saved')
        //  typeof onSave === 'function' && onSave(I18n.t('messages.saved'))
        alertMessage(successMessage)
        if ( !indexList && typeof handleSuccess === 'function') {
          handleSuccess("",invoiceNos,false)
        }else if(typeof handleUnmount === 'function'){
          handleUnmount(invoiceNos,false)
        }
        if(result?.errors && result.errors.length > 0){
          showErrors(result.errors)
        }
        setReasonModalVisible(false)
        setUnlockReason('')
        resetValues();
      } else {
        const errors = response.errors || []
        const needsReason = errors.some((err) => (
          typeof err === 'string' && err.toLowerCase().includes('reason for unlocking')
        ))
        if (needsReason) {
          showReasonModal = true
          setUnlockReason('')
          setReasonModalVisible(true)
        } else {
          showErrors(errors)
        }
        resetValues();
        
      }
    } catch (error) {
      alertMessage(error.message, 'error', 10)
    } finally {
      setLoading(false)
      if(!showReasonModal && typeof selectedInfo === 'string' && typeof handleOnModalClose === 'function'){
        handleOnModalClose()
      }
    }
  }

  const openReasonModal = () => {
    if (isFileGenerated || loading) return
    if (displayType === 'button' && isDisabled) return
    setUnlockReason('')
    setReasonModalVisible(true)
  }

  const renderIcon = () => (
    displayType === "button" ? (
      <Button
      data-testid={`unlock-icon-${dataTestId}`}
      type={buttonType ? buttonType : 'primary'}
      icon="unlock" 
      className={className ? className : ''}
      loading={loading}
      disabled={isDisabled}
      size={size ? size : 'default'}
    >
      {label}
    </Button>
    ) : (
   (isFileGenerated || !isPartiallyPaid ) && (
    <img
      data-testid={`locked-icon-${dataTestId}`}
      src={isFileGenerated ? lock : lockButton}
      className="expandIcon cursorPointer"
      alt={I18n.t('invoices.locked')}
      style={{ height:17, width: 17, ...styleObj }}
    />
  )
    )
  );

  const renderReasonModal = () => (
    <Modal
      visible={reasonModalVisible}
      onCancel={closeReasonModal}
      footer={null}
      closable={false}
      destroyOnClose
      width={460}
      className="update-remark-modal"
    >
      <Spin spinning={loading} size="small" tip="Unlocking...">
        <div className="update-remark-modal__header">
          <span className="update-remark-modal__title">Unlock Invoice</span>
          <Icon
            type="close"
            className="update-remark-modal__close-icon"
            onClick={closeReasonModal}
          />
        </div>
        <div className="update-remark-modal__body">
          <p className="update-remark-modal__description">
            Please provide a reason for unlocking this invoice. The invoice will move to Pending and can be edited.
          </p>
          <label className="update-remark-modal__label">
            Reason <span className="update-remark-modal__required">*</span>
          </label>
          <Input.TextArea
            className="update-remark-modal__textarea"
            placeholder="Enter unlock reason"
            value={unlockReason}
            maxLength={UNLOCK_REASON_MAX_LENGTH}
            autoSize={{ minRows: 4, maxRows: 4 }}
            onChange={e => setUnlockReason(e.target.value)}
            onPressEnter={e => {
              if (e.shiftKey) return
              e.preventDefault()
              if (!unlockReason.trim() || loading) return
              handleSave(unlockReason)
            }}
          />
          <div className="update-remark-modal__char-count">
            {unlockReason.length} / {UNLOCK_REASON_MAX_LENGTH}
          </div>
        </div>
        <div className="update-remark-modal__footer">
          <Button_v2
            size="medium"
            className="flat small-btn"
            onClick={closeReasonModal}
            disabled={loading}
            text="Cancel"
          />
          <Button_v2
            size="medium"
            className="small-btn raised"
            onClick={() => handleSave(unlockReason)}
            loading={loading}
            disabled={!unlockReason.trim()}
            text="Confirm & Unlock"
          />
        </div>
      </Spin>
    </Modal>
  )

  return (
    <Fragment>
      {
        requireAction ? (
          requireUnlockReason ? (
            <Tooltip title={isFileGenerated ? "Exported" : ""}>
              <span onClick={openReasonModal}>
                {renderIcon()}
              </span>
            </Tooltip>
          ) : (
            <Popconfirm
              placement="topRight"
              title={I18n.t('messages.action_confirm', { action:'unlock', field: ""})}
              onConfirm={requireAction ? handleSave : undefined}
              okText="Yes"
              cancelText="No"
              disabled={!requireAction || isFileGenerated}
            >
              <Tooltip title={isFileGenerated ? "Exported" : ""}>
                {renderIcon()}
              </Tooltip>
            </Popconfirm>
          )
        ) :
          <Tooltip title={isFileGenerated ? "Exported" : ""}>
            {renderIcon()}
          </Tooltip>}
      {renderReasonModal()}
    </Fragment>
  )
}

UnlockInvoice.propTypes = {
  invoiceIds: PropTypes.string.isRequired,
  buttonType: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  isDisabled: PropTypes.string.isRequired,
  invoiceIds: PropTypes.string.isRequired,
  size: PropTypes.string.isRequired,
  handleSuccess: PropTypes.func,
  displayType: PropTypes.string.isRequired,
  requireAction: PropTypes.bool.isRequired,
}
UnlockInvoice.defaultProps = {
  handleSuccess: () => {},
  displayType: "button",
  requireAction: true,
  indexList : false
}

export default UnlockInvoice;
